import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { states } from 'src/app/constants/states';
import { searchIconSVG } from 'src/app/constants/svgs/search-icon';
import { ServiceFilter } from 'src/app/models/all-services.model';

@Component({
  selector: 'app-service-state-filter',
  templateUrl: './service-state-filter.component.html',
  styleUrls: ['./service-state-filter.component.scss'],
})
export class ServiceStateFilterComponent implements OnInit {
  @Input() states:any[] = [];
  searchIconSVG = searchIconSVG;
  removedState = false;
  @Input() filterConfig!: ServiceFilter;
  @Input() allService:any
  @Input()
  set list(value: any) {    
    if(value?.length && this.states?.length){
      if(!this.removedState){
        this.states = this.states;
        this.removedState = true;
      }
    }
  };

  @Output() applyFilter = new EventEmitter<void>();

  constructor(
    private overlayContainer: OverlayContainer
  ) {}

  ngOnInit() {}

  onOpenedChange(isOpen: boolean) {
    const overlayPane = this.overlayContainer.getContainerElement().querySelector('.cdk-overlay-pane') as HTMLElement;

    if (overlayPane) {
      if (isOpen) {
        overlayPane.classList.add('state-filter-pane');
        overlayPane.style.width = '300px';
        setTimeout(() => {
          overlayPane.classList.add('state-filter-pane1');
        }, 100);
      } else {
        overlayPane.classList.remove('state-filter-pane');
      }
    }
  }


}
